import api, { URLS } from "@/services/api.js";

const BASE_URL = `${URLS.API_FGTAS}/parametros`;

// Retorna nome aplicacao, urlPortalServicos, logoAplicacao, etc
export const buscarParametros = () => {
	const url = `${BASE_URL}`;
	return api.get(url);
};
